import { useDispatch } from 'react-redux';
import React, { useState } from 'react';

import { Option } from '../../interfaces/option.interface';
import { notifyIntegratorRequested } from '../../redux/integrator/integrator.actions';
import Modal from '../../components/Modal';
import { Header3, P2 } from '../../components/Typography';
import { Action } from '../../components/Reposit/RepositSummary/styles';
import Button from '../../components/Button';
import {
  INTEGRATOR_PLACEHOLDER_VALUE,
  IntegratorConfirmationModal,
  IntegratorSelect,
} from '../../components/IntegratorSelect';
import { NotifyIntegratorPayload } from '../../redux/integrator/integrator.types';

interface NotifyModalProps {
  onDismiss: () => void;
  integratorOptions: Option[];
  userId: string;
  organizationId: string;
}

export const NotifyModal: React.FC<NotifyModalProps> = ({ onDismiss, integratorOptions, userId, organizationId }) => {
  const dispatch = useDispatch();
  const [integratorId, setIntegratorId] = useState(INTEGRATOR_PLACEHOLDER_VALUE);
  const [pendingNotification, setPendingNotification] = useState<NotifyIntegratorPayload | undefined>(undefined);
  const hasSelectedIntegrator = integratorId !== INTEGRATOR_PLACEHOLDER_VALUE;
  const onSubmit = () => {
    if (!hasSelectedIntegrator) return;

    setPendingNotification({ userId, organizationId, integratorId });
  };

  return (
    <Modal onDismiss={onDismiss}>
      <Header3 style={{ marginBottom: 6 }}>Notify Integrator</Header3>
      <P2>
        Please select an integrator below. The integrator will be provided with API credentials for this user, and the user will
        be notified that the integration has been enabled.
      </P2>
      <IntegratorSelect integratorOptions={integratorOptions} onSelect={setIntegratorId} selected={integratorId} />
      <Action style={{ marginTop: 16, justifyContent: 'flex-end', display: 'flex', flexDirection: 'row', columnGap: '10px' }}>
        <Button buttonType="secondary" noArrow={true} onClick={onDismiss}>
          Cancel
        </Button>

        <Button onClick={onSubmit} disabled={!hasSelectedIntegrator}>
          Confirm
        </Button>
      </Action>
      {pendingNotification ? (
        <IntegratorConfirmationModal
          integratorId={pendingNotification.integratorId}
          integratorOptions={integratorOptions}
          title={(integratorName) => `Send API keys to ${integratorName}?`}
          text={(integratorName) =>
            `This will send API credentials for this user to ${integratorName}. Please confirm the partner is correct.`
          }
          onDismiss={() => setPendingNotification(undefined)}
          onSubmit={() => {
            dispatch(notifyIntegratorRequested(pendingNotification));
            setPendingNotification(undefined);
            onDismiss();
          }}
        />
      ) : null}
    </Modal>
  );
};
